// export default function ( solutions, { minSection, maxSection, minThickness, maxThickness }) {
//     let i = 0;
//     let n = solutions.length;
//     let r = 0;
//     var res = [];

//     for (i = 0; i < n; ++i) {
//         r = solutions[i];

//         if (
//             r.Section >= minSection &&
//             r.Section <= maxSection &&
//             r.thickness >= minThickness && r.thickness <= maxThickness
//         ) {
//             //console.log( minSection, maxSection, minThickness, maxThickness , r.Section, r.thickness, r.type );
//             res.push({
//                 name: r.name,
//                 type: r.type,
//                 weight: r.weight,
//                 weightM2: r.weightM2,
//                 Section: r.Section,
//                 thickness: r.thickness,
//                 steel: r.steel
//             });
//         }
//     }

//     function cmp(a, b) {
//         if (a.weight < b.weight) return -1;

//         return a.weight > b.weight ? 1 : 0;
//     }

//     res.sort(cmp);

//     n = res.length;
//     let has_type_h = {};
//     let key;
//     let res_out = [];

//     // agora fica com apenas o primeiro de cada tipo
//     for (i = 0; i < n; ++i) {
//         r = res[i];
//         key = "k-" + r.type;
//         if (!!!has_type_h[key]) {
//             has_type_h[key] = 1;
//             res_out.push(r);
//         }
//     }

//     return res_out;
// }

export default function (
    solutions,
    { minSection, maxSection, minThickness, maxThickness, steels }
) {
    return solutions.filter(item => {
        let { section, thickness, steel } = item;

        //make sure theyre  ints
        section = +section;
        thickness = +thickness;

        return (
            section >= minSection &&
            section <= maxSection &&
            thickness >= minThickness &&
            thickness <= maxThickness &&
            steels.includes(steel) // JOPLO
        );
    });
}